import type { PostHog } from 'posthog-node'

import { posthogManager } from './manager'

type ErrorTracking = {
  error: Error | string
  properties?: Record<string, any>
  fingerprint: string
}

type SSRErrorTracking = ErrorTracking & {
  posthogInstance: PostHog
  userID?: string
}

export const errorTracking = ({
  error,
  properties = {},
  fingerprint
}: ErrorTracking) => {
  const posthog = posthogManager.getClientInstance()
  if (!posthog) return

  posthog?.captureException(error instanceof Error ? error.message : error, {
    $exception_fingerprint: fingerprint,
    error: error instanceof Error ? error : new Error(error),
    ...properties
  })
}
export const ssrErrorTracking = ({
  posthogInstance,
  userID,
  error,
  fingerprint,
  properties = {}
}: SSRErrorTracking) => {
  if (!posthogInstance) return

  posthogInstance?.captureException(
    error instanceof Error ? error.message : error,
    userID,
    {
      $exception_fingerprint: fingerprint,
      error: error instanceof Error ? error : new Error(error),
      ...properties
    }
  )
}

export const actionTracking = ({
  action,
  properties
}: {
  action: string
  properties?: Record<string, any>
}) => {
  const posthog = posthogManager.getClientInstance()
  if (!posthog) return

  posthog?.capture(action, {
    action,
    ...properties
  })
}
